<template lang="pug">
  .hostem-overview.mt-140(v-if="isHostem")
    //- makers links
    hostem-makers-links-columned.px-15.sm-px-100

    //- collection links
    template(v-if="winIs('md')")
      grid-scattered.mt-200(:items="gridItems", v-if="gridItems.length")
    template(v-else)
      ul.mt-67(v-if="gridItems.length")
        li.my-50(v-for="item in gridItems", :class="{'px-15': !imgPrt(item), 'px-40': imgPrt(item)}")
          products-collection-thumb(:post="item.post", :image="item.image")
</template>

<script>
import { mapGetters } from 'vuex'
import get from 'lodash/get'
import ProductsCollectionThumb from '@/components/Shop/ProductsCollectionThumb'
import HostemMakersLinksColumned from '@/components/Shop/HostemMakersLinksColumned'
export default {
  name: 'HostemOverview',
  props: ['doc'],
  computed: {
    ...mapGetters(['winIs']),
    isHostem () {
      return this.doc && this.doc.acf && Object.keys(this.doc.acf).includes('hostem_brands_list')
    },
    brandsList () {
      return get(this.doc, 'acf.hostem_brands_list')
    },
    gridItems () {
      const items = get(this.doc, 'acf.hostem_links_grid') || []
      return items.map(itm => ({
        type: itm.shopify_collection.post_type,
        post: itm.shopify_collection,
        image: itm.image
      }))
    }
  },
  methods: {
    imgPrt (item) {
      return item && item.image && item.image.height > item.image.width * 1.1
    }
  },
  components: { ProductsCollectionThumb, HostemMakersLinksColumned }
}
</script>

<style>
</style>
